import { z } from "zod";
import { EmailAddressSchema } from "./email.schemas.js";

export const CreateSessionBodySchema = z.object({
  token: z.string(),
});

// Shared response shape for the session-create, OAuth-session, and login
// flows — an optional auth token plus the post-auth redirect target. All three
// endpoints return the same payload.
export const AuthSessionResultSchema = z.object({
  token: z.string().optional(),
  redirect: z.string(),
});

export const LoginBodySchema = z.object({
  email: EmailAddressSchema,

  password: z.string().min(1),
});

// The OTP arrives from a link the user tapped, so a missing or empty code is a
// navigation to render, not a request to reject — hence optional rather than
// required.
export const OtpLinkQuerySchema = z.object({
  otp: z.string().optional(),
});

// Why the OTP link bounced, carried to the auth page as `?otpError=`.
export const OTP_LINK_ERROR_REASON_VALUES = {
  EXPIRED: "expired",
  GENERIC: "generic",
} as const;

export const OtpLinkErrorReasonSchema = z.enum(OTP_LINK_ERROR_REASON_VALUES);

export type CreateSessionBody = z.infer<typeof CreateSessionBodySchema>;

export type LoginBody = z.infer<typeof LoginBodySchema>;

export type AuthSessionResult = z.infer<typeof AuthSessionResultSchema>;

export type OtpLinkQuery = z.infer<typeof OtpLinkQuerySchema>;

export type OtpLinkErrorReason = z.infer<typeof OtpLinkErrorReasonSchema>;

export const OtpLinkErrorReason = {
  ...OTP_LINK_ERROR_REASON_VALUES,
} as const;
